import React from 'react'
const InfoComponent = (props) => {
    return (
        <div className="alert alert-info" role="alert">
            {props.info}
        </div>
    )
}
export default InfoComponent
